import { render, staticRenderFns } from "./EmailDetailDrawer.vue?vue&type=template&id=6703213a&scoped=true"
import script from "./EmailDetailDrawer.vue?vue&type=script&lang=js"
export * from "./EmailDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./EmailDetailDrawer.vue?vue&type=style&index=0&id=6703213a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6703213a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6703213a')) {
      api.createRecord('6703213a', component.options)
    } else {
      api.reload('6703213a', component.options)
    }
    module.hot.accept("./EmailDetailDrawer.vue?vue&type=template&id=6703213a&scoped=true", function () {
      api.rerender('6703213a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/EmailDetailDrawer.vue"
export default component.exports